import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-[#E6DEC3] mt-16" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-stone-500">
      <span className="mr-auto">© {new Date().getFullYear()} The Main Source LLC · ConsciousLearn</span>
      <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[#2C4A3E]">Privacy</Link>
      <Link to="/terms" data-testid="footer-terms" className="hover:text-[#2C4A3E]">Terms</Link>
      <Link to="/refunds" data-testid="footer-refunds" className="hover:text-[#2C4A3E]">Refunds & cancelling</Link>
      <Link to="/gift" data-testid="footer-gift" className="hover:text-[#2C4A3E]">Give a gift</Link>
      <Link to="/pricing" data-testid="footer-pricing" className="hover:text-[#2C4A3E]">Pricing</Link>
    </div>
  </footer>
);
